import type { SVGProps } from 'react';

const SvgIconPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5" d="M18 12H6" />
    <path
      d="M12 18L12 6"
      strokeWidth="1.5"
      strokeLinejoin="round"
      className="origin-center transition-transform"
      stroke="currentColor"
    />
  </svg>
);
export default SvgIconPlus;
